import { render, staticRenderFns } from "./routerView.vue?vue&type=template&id=307ecb9d"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('307ecb9d')) {
      api.createRecord('307ecb9d', component.options)
    } else {
      api.reload('307ecb9d', component.options)
    }
    module.hot.accept("./routerView.vue?vue&type=template&id=307ecb9d", function () {
      api.rerender('307ecb9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/routerView.vue"
export default component.exports